import { getConfigValuesAsync } from '@nutrien/ddc-fe-feature-flags';
import appConfig from './config';

enum SentryConfigKeys {
  ENABLED = 'sentryEnabled',
  REPLAYS_SESSION_SAMPLE_RATE = 'sentryReplaysSessionSampleRate',
  REPLAYS_ON_ERROR_SAMPLE_RATE = 'sentryReplaysOnErrorSampleRate',
  TRACES_SAMPLE_RATE = 'sentryTracesSampleRate',
  SAMPLE_RATE = 'sentrySampleRate',
}

export interface SentryConfig {
  enabled: boolean;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
  tracesSampleRate: number;
  sampleRate: number;
}

export async function resolveSentryConfig(): Promise<SentryConfig> {
  const configCatSdkKey = appConfig.configCatKey;

  const defaultConfig: SentryConfig = {
    enabled: true,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    tracesSampleRate: 0,
    sampleRate: 0,
  };

  if (!configCatSdkKey) {
    console.warn('ConfigCat key not found in app config, using default Sentry config');
    return defaultConfig;
  }

  try {
    return await getConfigValuesAsync(configCatSdkKey, {
      enabled: {
        key: SentryConfigKeys.ENABLED,
        defaultValue: false,
      },
      replaysSessionSampleRate: {
        key: SentryConfigKeys.REPLAYS_SESSION_SAMPLE_RATE,
        defaultValue: 0,
      },
      replaysOnErrorSampleRate: {
        key: SentryConfigKeys.REPLAYS_ON_ERROR_SAMPLE_RATE,
        defaultValue: 0,
      },
      tracesSampleRate: {
        key: SentryConfigKeys.TRACES_SAMPLE_RATE,
        defaultValue: 0,
      },
      sampleRate: {
        key: SentryConfigKeys.SAMPLE_RATE,
        defaultValue: 0,
      },
    });
  } catch (error) {
    console.error('Failed to fetch Sentry config from ConfigCat, using defaults:', error);
    return defaultConfig;
  }
}
